import * as XLSX from "xlsx";

/**
 * Download an XLSX template file with headers and sample data rows.
 * @param {string} filename - e.g. "states_template.xlsx"
 * @param {string[]} headers - column headers
 * @param {Array<Array<string|number|boolean>>} sampleRows - sample data rows
 */
export function downloadXlsxTemplate(filename, headers, sampleRows = []) {
  const ws = XLSX.utils.aoa_to_sheet([headers, ...sampleRows]);
  // Auto-size columns
  ws["!cols"] = headers.map((h) => ({ wch: Math.max(h.length + 4, 16) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template");
  XLSX.writeFile(wb, filename);
}

/**
 * Download an XLSX template file with multiple sheets.
 * @param {string} filename - e.g. "sets_template.xlsx"
 * @param {Array<{name: string, headers: string[], sampleRows?: Array<Array<string|number|boolean>>}>} sheets
 */
export function downloadXlsxMultiSheet(filename, sheets) {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, headers, sampleRows }) => {
    const ws = XLSX.utils.aoa_to_sheet([headers, ...(sampleRows || [])]);
    ws["!cols"] = headers.map((h) => ({ wch: Math.max(String(h).length + 4, 16) }));
    XLSX.utils.book_append_sheet(wb, ws, name);
  });
  XLSX.writeFile(wb, filename);
}
